<template>
  <div class="py-2">
    <div class="w-full">
      <div class="grid auto-rows-max grid-cols-5 gap-4">
        <div
          v-for="live in livesToShow"
          :key="live.id"
          class="group cursor-pointer"
          @click="selectLive(live)"
        >
          <div class="overflow-hidden">
            <div class="relative aspect-video overflow-hidden rounded-lg">
              <img
                :src="getField(live, resolvedFieldMap.thumbnail)"
                :alt="getField(live, resolvedFieldMap.title)"
                class="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
                @error="handleImageError"
              />
              <div
                class="absolute right-0 bottom-0 left-0 flex items-center justify-between rounded-b-lg px-2 py-5 text-xs text-white"
                style="
                  background: linear-gradient(
                    180deg,
                    rgba(0, 0, 0, 0) 0%,
                    #000000 100%
                  );
                "
              >
                <div>飞哥解说</div>
                <div>主播解说</div>
              </div>
              <div class="absolute top-0 right-0">
                <div
                  class="flex items-center rounded-tr-lg rounded-bl-lg px-2 py-1 text-xs font-semibold text-white"
                  style="
                    background: linear-gradient(
                      270deg,
                      #5ffbf1 0%,
                      #03db6c 100%
                    );
                  "
                >
                  <el-image
                    src="/common/live.png"
                    class="mr-1 h-[12px] w-[12px]"
                  ></el-image>
                  <span>{{ badgeText }}</span>
                </div>
              </div>
            </div>
            <div class="p-3">
              <h3 class="mb-1 line-clamp-1 text-sm font-bold dark:text-white">
                {{ getField(live, resolvedFieldMap.title) }}
              </h3>
              <div class="flex items-center justify-between">
                <p
                  class="mb-1 line-clamp-1 text-xs text-gray-600 dark:text-gray-400"
                >
                  {{ getField(live, resolvedFieldMap.subtitle) }}
                </p>
                <div
                  class="flex items-center gap-1 text-xs text-gray-600 dark:text-gray-400"
                >
                  <el-image
                    src="/common/star.png"
                    class="h-[16px] w-[12px]"
                  ></el-image>
                  <div class="text-xs">
                    {{ getField(live, resolvedFieldMap.viewers) }}
                  </div>
                </div>
              </div>
              <div
                v-if="showFollowBadge"
                class="mt-2 w-full rounded-full bg-gray-100 px-2 py-1 text-center text-xs text-gray-600 dark:bg-[#222222] dark:text-gray-300"
              >
                {{ $t("common.followed") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface LiveItem {
  id: string;
  [key: string]: any;
}

interface Props {
  lives?: LiveItem[];
  fieldMap?: {
    thumbnail?: string;
    title?: string;
    subtitle?: string;
    viewers?: string;
  };
  mode?: "live" | "replay";
  showFollowBadge?: boolean;
  navigateOnClick?: boolean;
  targetRoute?: string;
}

const props = defineProps<Props>();

const emit = defineEmits<{ liveSelect: [live: LiveItem] }>();

const resolvedFieldMap = computed(() => ({
  thumbnail: "thumbnail",
  title: "title",
  subtitle: "match",
  viewers: "viewers",
  ...(props.fieldMap || {}),
}));

const badgeText = computed(() =>
  props.mode === "replay" ? "比赛回放" : "Live直播",
);
const showFollowBadge = computed(() => props.showFollowBadge ?? true);
const navigateOnClick = computed(() => props.navigateOnClick ?? false);
const targetRoute = computed(() => props.targetRoute ?? "/live");

const fallbackLives: LiveItem[] = [
  {
    id: "1",
    title: "大帝",
    description: "足篮球彩分析推荐",
    thumbnail:
      "https://lqcos.beijxs.com/2025-03-31/d7fa6344bde5949e50447ab4a71c46e5.png",
    badge: "乐球直播",
    viewers: "1.04",
    match: "塞那乔其 VS 古比斯",
    category: "芬超",
  },
  {
    id: "2",
    title: "站长",
    description: "职业足球解说员",
    thumbnail:
      "https://lqcos.beijxs.com/2025-05-13/586c0b9a18a1a3aebe4c3ce5ab06a02e.jpg",
    badge: "乐球直播",
    viewers: "1.00",
    match: "塞那乔其 VS 古比斯",
    category: "芬超",
  },
  {
    id: "3",
    title: "雨哥电竞",
    description: "要玩电竞就跟雨哥!",
    thumbnail:
      "https://lqcos.beijxs.com/2025-11-14/b72d56303f37c4a1f52857f59b9a1d8d.png",
    badge: "乐球直播",
    viewers: "1.11",
    match: "哈萨征服 VS 利雅得体育",
    category: "沙王冠",
  },
  {
    id: "4",
    title: "清扬说球",
    description: "深耕足球领域二十余载",
    thumbnail:
      "https://lqcos.beijxs.com/2024-12-16/274cd25d6bc92f0fb9139f682dac1335.jpg",
    badge: "乐球直播",
    viewers: "1.10",
    match: "史莫哈 VS 艾尔格纳",
    category: "埃及超",
  },
  {
    id: "5",
    title: "怡宝",
    description: "足篮球女主播",
    thumbnail:
      "https://lqcos.beijxs.com/2025-03-31/baf458a5e8972e17c161fb1bfdf15a1f.JPG",
    badge: "乐球直播",
    viewers: "1.05",
    match: "史莫哈 VS 艾尔格纳",
    category: "埃及超",
  },
  {
    id: "1",
    title: "大帝",
    description: "足篮球彩分析推荐",
    thumbnail:
      "https://lqcos.beijxs.com/2025-03-31/d7fa6344bde5949e50447ab4a71c46e5.png",
    badge: "乐球直播",
    viewers: "1.04",
    match: "塞那乔其 VS 古比斯",
    category: "芬超",
  },
  {
    id: "2",
    title: "站长",
    description: "职业足球解说员",
    thumbnail:
      "https://lqcos.beijxs.com/2025-05-13/586c0b9a18a1a3aebe4c3ce5ab06a02e.jpg",
    badge: "乐球直播",
    viewers: "1.00",
    match: "塞那乔其 VS 古比斯",
    category: "芬超",
  },
  {
    id: "3",
    title: "雨哥电竞",
    description: "要玩电竞就跟雨哥!",
    thumbnail:
      "https://lqcos.beijxs.com/2025-11-14/b72d56303f37c4a1f52857f59b9a1d8d.png",
    badge: "乐球直播",
    viewers: "1.11",
    match: "哈萨征服 VS 利雅得体育",
    category: "沙王冠",
  },
  {
    id: "4",
    title: "清扬说球",
    description: "深耕足球领域二十余载",
    thumbnail:
      "https://lqcos.beijxs.com/2024-12-16/274cd25d6bc92f0fb9139f682dac1335.jpg",
    badge: "乐球直播",
    viewers: "1.10",
    match: "史莫哈 VS 艾尔格纳",
    category: "埃及超",
  },
  {
    id: "5",
    title: "怡宝",
    description: "足篮球女主播",
    thumbnail:
      "https://lqcos.beijxs.com/2025-03-31/baf458a5e8972e17c161fb1bfdf15a1f.JPG",
    badge: "乐球直播",
    viewers: "1.05",
    match: "史莫哈 VS 艾尔格纳",
    category: "埃及超",
  },
  {
    id: "1",
    title: "大帝",
    description: "足篮球彩分析推荐",
    thumbnail:
      "https://lqcos.beijxs.com/2025-03-31/d7fa6344bde5949e50447ab4a71c46e5.png",
    badge: "乐球直播",
    viewers: "1.04",
    match: "塞那乔其 VS 古比斯",
    category: "芬超",
  },
  {
    id: "2",
    title: "站长",
    description: "职业足球解说员",
    thumbnail:
      "https://lqcos.beijxs.com/2025-05-13/586c0b9a18a1a3aebe4c3ce5ab06a02e.jpg",
    badge: "乐球直播",
    viewers: "1.00",
    match: "塞那乔其 VS 古比斯",
    category: "芬超",
  },
  {
    id: "3",
    title: "雨哥电竞",
    description: "要玩电竞就跟雨哥!",
    thumbnail:
      "https://lqcos.beijxs.com/2025-11-14/b72d56303f37c4a1f52857f59b9a1d8d.png",
    badge: "乐球直播",
    viewers: "1.11",
    match: "哈萨征服 VS 利雅得体育",
    category: "沙王冠",
  },
  {
    id: "4",
    title: "清扬说球",
    description: "深耕足球领域二十余载",
    thumbnail:
      "https://lqcos.beijxs.com/2024-12-16/274cd25d6bc92f0fb9139f682dac1335.jpg",
    badge: "乐球直播",
    viewers: "1.10",
    match: "史莫哈 VS 艾尔格纳",
    category: "埃及超",
  },
  {
    id: "5",
    title: "怡宝",
    description: "足篮球女主播",
    thumbnail:
      "https://lqcos.beijxs.com/2025-03-31/baf458a5e8972e17c161fb1bfdf15a1f.JPG",
    badge: "乐球直播",
    viewers: "1.05",
    match: "史莫哈 VS 艾尔格纳",
    category: "埃及超",
  },
  {
    id: "1",
    title: "大帝",
    description: "足篮球彩分析推荐",
    thumbnail:
      "https://lqcos.beijxs.com/2025-03-31/d7fa6344bde5949e50447ab4a71c46e5.png",
    badge: "乐球直播",
    viewers: "1.04",
    match: "塞那乔其 VS 古比斯",
    category: "芬超",
  },
  {
    id: "2",
    title: "站长",
    description: "职业足球解说员",
    thumbnail:
      "https://lqcos.beijxs.com/2025-05-13/586c0b9a18a1a3aebe4c3ce5ab06a02e.jpg",
    badge: "乐球直播",
    viewers: "1.00",
    match: "塞那乔其 VS 古比斯",
    category: "芬超",
  },
  {
    id: "3",
    title: "雨哥电竞",
    description: "要玩电竞就跟雨哥!",
    thumbnail:
      "https://lqcos.beijxs.com/2025-11-14/b72d56303f37c4a1f52857f59b9a1d8d.png",
    badge: "乐球直播",
    viewers: "1.11",
    match: "哈萨征服 VS 利雅得体育",
    category: "沙王冠",
  },
  {
    id: "4",
    title: "清扬说球",
    description: "深耕足球领域二十余载",
    thumbnail:
      "https://lqcos.beijxs.com/2024-12-16/274cd25d6bc92f0fb9139f682dac1335.jpg",
    badge: "乐球直播",
    viewers: "1.10",
    match: "史莫哈 VS 艾尔格纳",
    category: "埃及超",
  },
  {
    id: "5",
    title: "怡宝",
    description: "足篮球女主播",
    thumbnail:
      "https://lqcos.beijxs.com/2025-03-31/baf458a5e8972e17c161fb1bfdf15a1f.JPG",
    badge: "乐球直播",
    viewers: "1.05",
    match: "史莫哈 VS 艾尔格纳",
    category: "埃及超",
  },
];

const livesToShow = computed<LiveItem[]>(() => {
  const list = props.lives || [];
  return list.length ? list : fallbackLives;
});

const getField = (obj: any, key: string) => obj?.[key];

const selectLive = (live: LiveItem) => {
  emit("liveSelect", live);
  if (navigateOnClick.value && live?.id) {
    const router = useRouter();
    router.push(`${targetRoute.value}/${live.id}`);
  }
};

const handleImageError = (e: Event) => {
  const target = e.target as HTMLImageElement;
  target.src = "https://via.placeholder.com/200x120/94a3b8/ffffff?text=直播";
};
</script>

<style scoped>
.line-clamp-1 {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
